import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';
import InstitutionLogo from '@/components/common/InstitutionLogo';
import usePageTitle from '@/shared/hooks/usePageTitle';
import {
    OPTIONAL_EMAILS,
    AlwaysSentEmails,
    readEmailPreferences,
} from './EmailPreferences';

function ProfilePage() {
    usePageTitle('My profile');
    const { currentUser, userProfile } = useAuth();
    const emailPreferences = readEmailPreferences(userProfile);

    return (
        <Container className="py-4">
            <Row>
                <Col lg={8} className="mx-auto">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            {/*
                              Level is structural, the h4 class carries the
                              size. This is the page's title, and the page had
                              no h1 at all, so anyone navigating by heading had
                              nothing to land on.
                            */}
                            <h1 className="h4 mb-0">My Profile</h1>
                            <Button
                                as={Link}
                                to="/profile/edit"
                                variant="outline-primary"
                                size="sm"
                            >
                                Edit Profile
                            </Button>
                        </Card.Header>
                        <Card.Body>
                            <h2 className="h5 d-flex align-items-center gap-2">
                                {userProfile?.name || 'Name not set'}
                                {userProfile?.institution && (
                                    <InstitutionLogo
                                        institution={userProfile.institution}
                                    />
                                )}
                            </h2>
                            <p className="text-muted">{currentUser?.email}</p>

                            {userProfile?.department && (
                                <p>
                                    <strong>Department:</strong>{' '}
                                    {userProfile.department}
                                </p>
                            )}

                            {userProfile?.phone && (
                                <p>
                                    <strong>Phone:</strong> {userProfile.phone}
                                </p>
                            )}

                            {/*
                              Always shown, unlike department and phone: a
                              member deciding whether mail from the exchange
                              is something they signed up for should not have
                              to open the edit form to find out.
                            */}
                            <section aria-labelledby="email-heading">
                                <h2 id="email-heading" className="h6 mt-3">
                                    Email
                                </h2>
                                <dl className="row mb-0">
                                    {OPTIONAL_EMAILS.map(({ key, label }) => (
                                        <React.Fragment key={key}>
                                            <dt className="col-sm-8 fw-normal">
                                                {label}
                                            </dt>
                                            <dd className="col-sm-4">
                                                {emailPreferences[key]
                                                    ? 'On'
                                                    : 'Off'}
                                            </dd>
                                        </React.Fragment>
                                    ))}
                                </dl>
                                <AlwaysSentEmails headingLevel="h3" />
                            </section>

                            <Button
                                as={Link}
                                to="/listings/mine"
                                variant="primary"
                                className="mt-2"
                            >
                                My listings
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default ProfilePage;
